import {combineReducers} from 'redux'
import userSlice  from "../slice/UserSlice"
const reducer = combineReducers({
    authUser: userSlice,
})
export default reducer